import React from 'react';

/**
 * Like React.lazy but adds a preload() method for SSR.
 * Usage: lazyWithPreload(() => import('./MyComponent'))
 */
export function lazyWithPreload(importFn: () => Promise<any>): any {
  const Lazy = React.lazy(importFn) as any;
  Lazy.preload = importFn;
  return Lazy;
}
